export function deepCopy<T>(obj: T): T {
  if (Array.isArray(obj)) {
    return obj.map((item) => deepCopy(item)) as unknown as T;
  } else if (obj && typeof obj === 'object') {
    const result: Partial<Record<keyof T, any>> = {};
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        const typedKey = key as keyof T;
        result[typedKey] = deepCopy((obj as Record<string, any>)[key]);
      }
    }
    return result as T;
  } else {
    return obj;
  }
}
